import { ProjectFieldRequirement, ProjectPageName, ProjectSectionName, ProjectKey, ProjectFieldType, } from "./project.data.dtos";
export const projectData = [
    {
        pageName: ProjectPageName.PROJECT_DETAILS,
        sectionName: ProjectSectionName.OVERVIEW,
        fieldName: "title",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        placeholder: "Please enter the official title of the project",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_DETAILS,
        sectionName: ProjectSectionName.OVERVIEW,
        fieldName: "description",
        fieldType: ProjectFieldType.TEXTFIELD,
        multiline: true,
        minRows: 4,
        label: "Description",
        placeholder: "Please enter a description of the project for others at your organization",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_DETAILS,
        sectionName: ProjectSectionName.OVERVIEW,
        fieldName: "protocolNumber",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Project reference number",
        placeholder: "ex. BB100-I-02",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_SETTINGS,
        sectionName: ProjectSectionName.PATIENT_OUTREACH_SETTINGS,
        fieldName: "suppressNotifications",
        fieldType: ProjectFieldType.RADIO,
        label: "How will you reach out to patients?",
        options: [
            {
                label: "We’ll use HealthEx to send patient notifications and automatic reminders (recommended)",
                value: false,
            },
            {
                label: "We’ll notify patients manually outside of HealthEx",
                value: true,
            },
        ],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_SETTINGS,
        sectionName: ProjectSectionName.PATIENT_RECORD_RETRIEVAL_RECENCY,
        fieldName: "patientRecordRetrievalRecencyEnabled",
        fieldType: ProjectFieldType.SWITCH,
        label: "This project requires recently retrieved patient records",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_SETTINGS,
        sectionName: ProjectSectionName.PATIENT_RECORD_RETRIEVAL_RECENCY,
        specialFieldName: "patientRecordRetrievalRecency",
        fieldIncludeFields: ["patientRecordRetrievalRecencyEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PROJECT_SETTINGS,
        sectionName: ProjectSectionName.HEALTH_RECORD_UPDATE_SETTINGS,
        specialFieldName: "healthRecordUpdates",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldType: ProjectFieldType.SUBSECTION,
        showSubsectionDivider: false,
        label: "Initial record access request",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldName: "welcomeTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        translationLabel: "Initial record access request title",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholderKey: "welcomeTitle",
        characterLimit: 65,
        translatableFieldNames: ["welcomeTitle"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldName: "welcomeText",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Description",
        translationLabel: "Initial record access request description",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholderKey: "welcomeText",
        characterLimit: 140,
        multiline: true,
        minRows: 2,
        translatableFieldNames: ["welcomeText"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        specialFieldName: "organizationIcon",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldType: ProjectFieldType.SUBSECTION,
        showSubsectionDivider: true,
        label: "Health record update request",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldName: "dataUpdateWelcomeTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        translationLabel: "Health record update request title",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholderKey: "dataUpdateWelcomeTitle",
        characterLimit: 65,
        translatableFieldNames: ["dataUpdateWelcomeTitle"],
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.WELCOME,
        fieldName: "dataUpdateWelcomeText",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Description",
        translationLabel: "Health record update request description",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholderKey: "dataUpdateWelcomeText",
        characterLimit: 140,
        multiline: true,
        minRows: 2,
        translatableFieldNames: ["dataUpdateWelcomeText"],
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.REQUEST_DETAILS,
        fieldName: "purposeOfDataBriefEducation",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Reason for the request",
        placeholderKey: "purposeOfDataBriefEducation",
        multiline: true,
        minRows: 4,
        translatableFieldNames: ["purposeOfDataBriefEducation"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.REQUEST_DETAILS,
        viewOnlyFieldName: "requestingOrganization",
        label: "Organization",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.REQUEST_DETAILS,
        viewOnlyFieldName: "consentDuration",
        label: "Consent duration",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.REQUEST_DETAILS,
        fieldName: "patientFriendlyTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Request title",
        placeholderKey: "patientFriendlyTitle",
        translatableFieldNames: ["patientFriendlyTitle"],
        informedConsentFieldNames: ["patientFriendlyTitle"],
        multiline: true,
        minRows: 2,
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.REQUEST_DETAILS,
        specialFieldName: "purposeOfDataDisclosure",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        specialFieldName: "frequentlyAskedQuestions",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldType: ProjectFieldType.SUBSECTION,
        label: "Will you need to access my records again in the future?",
        subsectionFooterText: "continueAccessingRecords",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "healthRecordUpdatesText",
        fieldType: ProjectFieldType.TEXTFIELD,
        multiline: true,
        minRows: 4,
        label: "Explanation of health record update requests",
        placeholder: "Please enter an explanantion of the health record update request.",
        translatableFieldNames: ["healthRecordUpdatesText"],
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldType: ProjectFieldType.SUBSECTION,
        label: "Who can I contact with questions?",
        showSubsectionDividerKey: "healthRecordsUpdatesEnabled",
        subsectionHeaderText: "whoToContactHeader",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "sitePrimaryContactName",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Contact person or department name",
        placeholder: "Add a name",
        informedConsentFieldNames: ["sitePrimaryContactName"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "sitePrimaryContactTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        placeholder: "Add a title",
        informedConsentFieldNames: ["sitePrimaryContactTitle"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "sitePrimaryContactEmail",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Email",
        placeholder: "Add an email",
        informedConsentFieldNames: ["sitePrimaryContactEmail"],
        additionalHelperText: "At least one contact method is required.",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        specialFieldName: "sitePrimaryContactPhoneNumber",
        informedConsentFieldNames: ["sitePrimaryContactPhone"],
        additionalHelperText: "At least one contact method is required.",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "sitePrimaryContactLink",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Link",
        placeholder: "https://",
        informedConsentFieldNames: ["sitePrimaryContactLink"],
        additionalHelperText: "At least one contact method is required.",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldName: "contactDetails",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Details",
        placeholder: "Include any helpful details about how or when to contact this person or department.",
        multiline: true,
        minRows: 4,
        translatableFieldNames: ["contactDetails"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        fieldType: ProjectFieldType.SUBSECTION_END,
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.FREQUENTLY_ASKED_QUESTIONS,
        specialFieldName: "additionalQuestions",
        showSubsectionDivider: true,
        translatableFieldNames: ["additionalQuestions"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRM_ACCESS,
        viewOnlyFieldName: "initialRecordAccessRequestTitle",
        label: "Title",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.FORCE_SECTION_REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRM_ACCESS,
        viewOnlySpecialCaseFieldName: "initialRecordAccessRequestConsent",
        label: "Consent",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRM_ACCESS,
        fieldName: "informedConsentStatement",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Additional statement",
        placeholder: "Include any information you want to legally show above the signature",
        multiline: true,
        minRows: 4,
        translatableFieldNames: ["informedConsentStatement"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldType: ProjectFieldType.SUBSECTION,
        label: "Initial health record access request",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldName: "thankYouConsentedTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        translationLabel: "Initial health record access request title",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholder: "Please enter a title",
        characterLimit: 65,
        translatableFieldNames: ["thankYouConsentedTitle"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldName: "thankYouConsentedText",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Description",
        translationLabel: "Initial health record access description",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholder: "Please enter a description",
        multiline: true,
        minRows: 2,
        characterLimit: 140,
        translatableFieldNames: ["thankYouConsentedText"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        viewOnlySpecialCaseFieldName: "thankYouConsentedAdditionalInformation",
        label: "Additional information",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldType: ProjectFieldType.SUBSECTION,
        showSubsectionDivider: true,
        label: "Health record update request",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldName: "dataUpdateThankYouConsentedTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        translationLabel: "Health record update request title",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholder: "Please enter a title",
        characterLimit: 65,
        translatableFieldNames: ["dataUpdateThankYouConsentedTitle"],
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        fieldName: "dataUpdateThankYouConsentedText",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Description",
        translationLabel: "Health record update request description",
        useTranslationLabelFieldName: "healthRecordsUpdatesEnabled",
        placeholder: "Please enter a description",
        multiline: true,
        minRows: 2,
        characterLimit: 140,
        translatableFieldNames: ["dataUpdateThankYouConsentedText"],
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_RECORDS_SHARED,
        viewOnlySpecialCaseFieldName: "dataUpdateThankYouConsentedAdditionalInformation",
        label: "Additional information",
        fieldIncludeFields: ["healthRecordsUpdatesEnabled"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_DECLINE,
        fieldName: "thankYouDeclinedTitle",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Title",
        placeholder: "Please enter a title",
        characterLimit: 65,
        translatableFieldNames: ["thankYouDeclinedTitle"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_DECLINE,
        fieldName: "thankYouDeclinedText",
        fieldType: ProjectFieldType.TEXTFIELD,
        label: "Description",
        placeholder: "Please enter a description",
        multiline: true,
        minRows: 2,
        characterLimit: 140,
        translatableFieldNames: ["thankYouDeclinedText"],
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.REQUIRED,
        },
    },
    {
        pageName: ProjectPageName.PATIENT_EXPERIENCE,
        sectionName: ProjectSectionName.CONFIRMATION_OF_DECLINE,
        viewOnlySpecialCaseFieldName: "thankYouDeclinedTextAdditionalInformation",
        label: "Additional information",
        fieldRequirements: {
            [ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE]: ProjectFieldRequirement.OPTIONAL,
        },
    },
];
